/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useState } from 'react'
import { Typography, Box, Button, TextField } from '@mui/material';
import PrimaryCard from "../../Shared/components/Card/PrimaryCard";
import customStyles from "../../../assets/styles/customStyles";
import { Col, Row, } from "antd";
import UserProfileIcon from "../../../assets/images/icon_menus/UserProfile.json";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Auth/redux/actions";
import { NavLink, useParams } from "react-router-dom";
import clsx from "clsx";
import MainHeader from "../../Shared/components/Header";
import { customAlaphabetValidation, emptyValidation } from "../../../helpers/validation";
import usePrevious from "../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { AutoCompleteComponent } from "../../Shared/components/AutoCompleteComponent";
import addressActions from "../../Admin/Address/redux/actions";


const UserProfile = (props) => {
    const { userDetails, userDetailsLoader, updateProfileDetails, updateProfileError, updateProfileLoader } = useSelector(state => state.authReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { languageDetails } = useSelector(state => state.addressReducer);

    let { userId } = useParams();
    const [view, setView] = useState(true);
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const prevUpdateProfileDetails = usePrevious(updateProfileDetails);
    const prevUpdateProfileError = usePrevious(updateProfileError);

    const dispatch = useDispatch();

    useEffect(() => {
        loadUserDetails();
    }, []);

    const loadUserDetails = useCallback(() => {
        dispatch({
            type: addressActions.LANGUAGE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.USER_DETAILS_START,
            id: userId
        });
    });

    const handleEdit = () => {
        setView(false);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyName = customAlaphabetValidation('Full Name', form?.name);
        // let phoneValidation = customPhoneValidation('Phone Number', form?.mobile);
        // let emailValidation = customEmailValidation('Email', form?.email);
        let languageValidation = emptyValidation('Preferred Language', form?.languageId, 'dropDown');
        setError({});
        if (emptyName.isValid && languageValidation.isValid) {
            dispatch({
                type: actions.UPDATE_PROFILE_DETAILS_START,
                updateData: {
                    name: form?.name,
                    languageId: form?.languageId
                }
            });
        } else {
            setError({
                name: emptyName?.errors || false,
                // mobile: phoneValidation?.errors || false,
                // email: emailValidation?.errors || false,
                languageId: languageValidation?.errors || false
            })
        }
    }

    useEffect(() => {
        if (prevUpdateProfileDetails !== undefined && updateProfileDetails && prevUpdateProfileDetails !== updateProfileDetails) {
            toast.dismiss();
            toast(updateProfileDetails.message);
            setView(true);
        } else if (prevUpdateProfileError !== undefined && updateProfileError && prevUpdateProfileError !== updateProfileError) {
            setError({
                name: updateProfileError?.error?.message || ''
            })
        }
    }, [updateProfileDetails, updateProfileError]);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    useEffect(() => {
        if (userDetails !== '') {
            setForm(userDetails);
        }
    }, [userDetails]);

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e.id,
                'language': e
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            })
        }
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} title={'User Profile'} img={UserProfileIcon}
                links={[{ 'label': 'My Profile', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'User Profile Detail'}
                    component={
                        <>
                            {
                                userDetailsLoader === true ? (
                                    <div style={{ textAlign: "center" }}>
                                        <div className={classes.loadMoreCircle}></div>
                                    </div>
                                ) : <Box
                                    className={clsx(classes.teamForm, classes.removeUnderline)}
                                    component="form"
                                    autoComplete="off"
                                    onSubmit={(e) => handleSubmit(e)}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                    <Row gutter={50}>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                            {view ?
                                                <NavLink to={'#'} onClick={() => handleEdit()} className={clsx(classes.AddMoreBtn, classes.bold)}>Edit</NavLink> :
                                                <Button
                                                    type='submit'
                                                    color='primary'
                                                    variant="contained"
                                                    fullWidth
                                                    style={{ width: "auto" }}
                                                    className={clsx(classes.modalBtn, classes.bold, { [classes.loading]: updateProfileLoader })}>
                                                    Update
                                                </Button>
                                            }
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Row>
                                                <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={24}>
                                                    {
                                                        view ? <Typography variant={'h6'} className={clsx(classes.bold, classes.textCapital)}>{form?.name}</Typography>
                                                            : <TextField
                                                                autoComplete='one-time-code'
                                                                label='Name'
                                                                fullWidth
                                                                name="name"
                                                                value={form?.name}
                                                                error={error?.name && true}
                                                                helperText={error?.name}
                                                                variant={'standard'}
                                                                className={classes.margin10t}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                            />
                                                    }
                                                    <Typography variant={'subtitle1'} style={{ marginTop: 10, lineHeight: 1 }} className={clsx(classes.fonSize13)}><span className={clsx(classes.colorLine, classes.bold)}>{businessDetails.serialNo}</span> Active</Typography>
                                                </Col>
                                            </Row>

                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Mobile Number</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.mobile || '---'}</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Email</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.email || '---'}</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Role</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.role?.name || '---'}</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            {
                                                view ? <>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Preferred Language</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)} >{form?.language?.name || 'English'}</Typography></>
                                                    : <AutoCompleteComponent
                                                        name={["Preferred Language ", <span key="Preferred Language" className={classes.colorRedRequired}> *</span>]}
                                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                        details={languageDetails}
                                                        parentValue={customObject(languageDetails, form?.languageId)}
                                                        onChange={(data) => changeHandler(data, 'languageId')}
                                                        position={"bottom"}
                                                        parentError={error?.languageId}
                                                        customClasses={classes.margin30t}
                                                    />
                                            }
                                        </Col>
                                    </Row>
                                </Box>
                            }

                        </>
                    }
                />
            </div>
        </React.Fragment>
    );
}
export default UserProfile